<template>
	<component
		:is="outerTag"
		class="card card--no-gutter news-list-item list-item list-item--simple grid-noGutter"
		:class="{ 'list-item--mounted': isMounted }"
		:href="data.link"
	>
		<span class="news-list-item_icon" v-html="IconDocument"></span>
		<div class="news-list-item__copy">
			<p
				class="news-list-item__date"
				:aria-describedby="'news-title__' + data.id"
			>
				{{
					sameDate
						? formatDateNoLeadingZeros(data.startDate, false, true)
						: formatDateTimeNoLeadingZeros(
								data.startDate,
								at,
								true,
								true
						  )
				}}
				{{
					data.endDate && data.endDate != "0001-01-01T00:00:00"
						? sameDate == true
							? at +
							  " " +
							  parseInt(
									(
										"0" +
										new Date(data.startDate).getHours()
									).slice(-2)
							  ) +
							  "-" +
							  parseInt(
									(
										"0" + new Date(data.endDate).getHours()
									).slice(-2)
							  )
							: " " +
							  (textTo != "" ? textTo : "-") +
							  " " +
							  formatDateTimeNoLeadingZeros(
									data.endDate,
									at,
									true,
									true
							  )
						: ""
				}}
			</p>
			<h3
				class="news-list-item__title header-extra-small"
				:id="'news-title__' + data.id"
			>
				{{ data.title }}
			</h3>
			<span class="news-list-item__description body-text-small">
				{{ data.description }}
			</span>
		</div>
	</component>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import IconDocument from "../../../../views/icons/document.cshtml";
import {
	formatDateTimeNoLeadingZeros,
	formatDateNoLeadingZeros,
} from "../../../shared/script/utilities";

const props = defineProps({
	data: Object,
	at: String,
	textTo: String,
});

const isMounted = ref(false);
const outerTag = ref("div");

onMounted(() => {
	setTimeout(() => {
		isMounted.value = true;
	}, 10);
	outerTag.value = props.data.disableLink !== true ? "a" : "div";
});

const sameDate = computed(() => {
	const date1 = new Date(props.data.startDate);
	const date2 = new Date(props.data.endDate);
	return (
		date1 &&
		date2 &&
		date1.getDate() === date2.getDate() &&
		date1.getMonth() === date2.getMonth() &&
		date1.getFullYear() === date2.getFullYear()
	);
});
</script>

<!-- <script>
import IconDocument from "../../../../views/icons/document.cshtml";
import Pattern from "../../../../views/visuals/leafPatternLarge.cshtml";
import {
	formatDateTimeNoLeadingZeros,
	formatDateNoLeadingZeros
} from "../../../shared/script/utilities";
export default {
	name: "listItem",
	data() {
		return { IconDocument, isMounted: false, Pattern, outerTag: "div" };
	},
	props: ["data", "at", "textTo"],
	mounted() {
		const self = this;
		setTimeout(() => {
			self.isMounted = true;
		}, 10);
		this.outerTag = this.data.disableLink !== true ? "a" : "div";
	},
	methods: {
		formatDateTimeNoLeadingZeros,
		formatDateNoLeadingZeros
	},
	computed: {
		showPattern: function() {
			if (this.data.image.length == 0) {
				return true;
			} else {
				return false;
			}
		},
		sameDate: function() {
			var date1 = new Date(this.data.startDate);
			var date2 = new Date(this.data.endDate);
			return (
				date1 &&
				date2 &&
				date1.getDate() == date2.getDate() &&
				date1.getMonth() == date2.getMonth() &&
				date1.getFullYear() == date2.getFullYear()
			);
		}
	}
};
</script> -->
